/**
 * @generated SignedSource<<addc12c273dde2f1037f7d3581f03710>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSendToFriendModalLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AuthShareModal_user">;
  readonly " $fragmentType": "PdpSharedSendToFriendModalLazy_user";
};
export type PdpSharedSendToFriendModalLazy_user$key = {
  readonly " $data"?: PdpSharedSendToFriendModalLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSendToFriendModalLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSendToFriendModalLazy_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AuthShareModal_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e3f5c435a70cdcebc02692e7118c25b6";

export default node;
